import axiosInstance from "../axios";
import { BRANDS } from "../../utils/endPoints";
import { brandsAction } from "./slice";

export const getBrands = function () {
  return async (dispatch: Function) => {
    dispatch(brandsAction.setLoadingBrands(true));
    try {
      const config = {
        url: `${BRANDS}`,
        method: "GET",
        timout: 0,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      };
      const response = await axiosInstance(config);
      dispatch(brandsAction.setBrands(response.data));
    } catch (error) {}
  };
};
